export default __webpack_public_path__ + "static/media/touranment_award.041268ec.png";